import React, { useRef, useState } from "react";
import { Button, Slider, Flex } from "antd";
import { PlayCircleOutlined, PauseCircleOutlined } from "@ant-design/icons";
import "./AudioPlayer.scss";
import { ReactComponent as Previous } from "../../assets/Icons/Previous.svg";
import { ReactComponent as Next } from "../../assets/Icons/Next.svg";
import { ReactComponent as AudioDownload } from "../../assets/Icons/AudioDownload.svg";
import { ReactComponent as Play } from "../../assets/Icons/Play.svg";

const AudioPlayer = ({
  src,
  rewindSeconds = 10,
  forwardSeconds = 10,
}) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (!audio) return;
    setCurrentTime(audio.currentTime);
  };

  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    if (!audio) return;
    setDuration(audio.duration);
  };

  const handleSliderChange = (value) => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = value;
    setCurrentTime(value);
  };

  const formatTime = (time) => {
    const hrs = Math.floor(time / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((time % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const rewind = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = Math.max(0, audio.currentTime - rewindSeconds);
  };

  const forward = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = Math.min(duration, audio.currentTime + forwardSeconds);
  };

  return (
    <div className="audio-player">
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
      />

      <div
        className="audio-player-main"
      >
        <div className="player-button">
          <Button icon={<Previous />} onClick={rewind} />

          <Button
            icon={playing ? <PauseCircleOutlined /> : <Play />}
            onClick={togglePlay}
          />

          <Button icon={<Next />} onClick={forward} />
        </div>

        <Slider
          min={0}
          max={duration}
          value={currentTime}
          onChange={handleSliderChange}
          // style={{ flex: 1, minWidth: 100 }}
        />
        <div className="duration-and-button">
          <span>{formatTime(duration)}</span>
          <Button icon={<AudioDownload />} href={src} download />
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
